import React, { useEffect, useRef } from 'react';
import { LocalVideoTrack, RemoteVideoTrack } from 'twilio-video';

interface Props {
  track: LocalVideoTrack | RemoteVideoTrack;
  isLocal?: boolean;
}

const VideoTrack: React.FC<Props> = ({ track, isLocal }: Props) => {
  const ref = useRef<HTMLVideoElement>(null!);

  useEffect(() => {
    const element = ref.current;
    element.muted = true;
    track.attach(element);

    return () => {
      track.detach(element);
    };
  }, [track]);

  const style = {
    transform: isLocal ? 'rotateY(180deg)' : '',
    objectFit: 'cover' as const,
    width: "100%",
    height: "100%"
  };

  return <video ref={ref} style={style} />;
};

export default VideoTrack;
